import { render, staticRenderFns } from "./CompleteSignUp.vue?vue&type=template&id=3e84bb4a"
import script from "./CompleteSignUp.vue?vue&type=script&lang=js"
export * from "./CompleteSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports